<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.eventCode" clearable placeholder="事件码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.templateName" clearable placeholder="名称" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="eventCode" label="事件码" width="180" />
      <el-table-column prop="templateName" label="名称" width="160" />
      <el-table-column prop="subject" label="主题" min-width="220" show-overflow-tooltip />
      <el-table-column label="启用" width="80" align="center">
        <template slot-scope="{ row }"><el-tag size="small" :type="row.active === '1' ? 'success' : 'info'">{{ row.active === '1' ? '是' : '否' }}</el-tag></template>
      </el-table-column>
      <el-table-column label="操作" width="140" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.templateId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.templateId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />
    <el-dialog :title="form.templateId ? '修改模板' : '新增模板'" :visible.sync="visible" width="640px" :close-on-click-modal="false">
      <el-form :model="form" label-width="90px">
        <el-form-item label="事件码"><el-input v-model="form.eventCode" placeholder="如 MAINTENANCE_DUE" /></el-form-item>
        <el-form-item label="名称"><el-input v-model="form.templateName" /></el-form-item>
        <el-form-item label="主题"><el-input v-model="form.subject" placeholder="支持 ${变量}" /></el-form-item>
        <el-form-item label="正文"><el-input v-model="form.body" type="textarea" :rows="8" placeholder="支持 ${变量}" /></el-form-item>
        <el-form-item label="启用"><el-switch v-model="form.active" active-value="1" inactive-value="0" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listEmailTemplate, getEmailTemplate, saveEmailTemplate, updateEmailTemplate, deleteEmailTemplate } from '../../api/email'

function emptyForm() {
  return { templateId: '', eventCode: '', templateName: '', subject: '', body: '', active: '1' }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { eventCode: '', templateName: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      visible: false, saving: false, form: emptyForm()
    }
  },
  created() { this.load() },
  methods: {
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listEmailTemplate({ currentPage: this.page, pageSize: this.pageSize, eventCode: this.query.eventCode, templateName: this.query.templateName })
        .then(res => {
          const body = res.data || {}
          this.list = body.list || []
          this.total = body.totalCount || 0
        }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      if (!id) { this.form = emptyForm(); this.visible = true; return }
      getEmailTemplate(id).then(res => {
        const d = res.data || {}
        this.form = { templateId: d.templateId, eventCode: d.eventCode, templateName: d.templateName, subject: d.subject, body: d.body, active: d.active || '1' }
        this.visible = true
      })
    },
    submit() {
      if (!this.form.eventCode || !this.form.templateName) { this.$message.warning('事件码和模板名称不能为空'); return }
      if (!this.form.subject || !this.form.body) { this.$message.warning('主题和正文不能为空'); return }
      this.saving = true
      const req = this.form.templateId ? updateEmailTemplate(this.form) : saveEmailTemplate(this.form)
      req.then(() => { this.$message.success('已保存'); this.visible = false; this.load() }).finally(() => { this.saving = false })
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteEmailTemplate([id]).then(() => { this.$message.success('已删除'); this.load() })
      }).catch(() => {})
    }
  }
}
</script>
